<x-shop-dialog (closeDialog)="cancel()">
  <header xHeader class="tw:px-16 tw:pb-16 tw:flex tw:flex-col tw:gap-16">
    <div class="tw:type-headline-default tw:text-content-default" [innerHTML]="heading"></div>
    <x-subscriber-pills [subscribers]="data.subscribers"></x-subscriber-pills>
    <div [innerHTML]="subheading"></div>
  </header>

  <x-address-book
    [user]="data.user"
    [addresses]="data.userAddresses ?? []"
    (addressCreated)="addressCreated($event)"
    (addressSelected)="setAsDefaultAddress($event)"
    [defaultCountry]="data.defaultCountry"
    [addressActions]="['create']"
    [radioButton]="false"
    [showArrow]="true"
    borderColor="primary"
    origin="My Account"
    i18-addressTooltip="@@Tooltip.SetAsDefault"
    addressTooltip="Set as default"
  ></x-address-book>
</x-shop-dialog>
